<div class="container">
    <span class="title">{{title}}</span>
    <span class="text">{{body}}</span>
    <div class="inputs">
        <input
            matInput
            placeholder="{{ placeholderFirst }}"
            autocomplete="off"
            spellcheck="false"
            #textInput
            [(ngModel)]="inputFirst"
            type="text"
        />
        <input
            matInput
            placeholder="{{ placeholderSecond }}"
            autocomplete="off"
            spellcheck="false"
            #textInput
            [(ngModel)]="inputSecond"
            type="text"
        />
    </div>
    <span class="agent">If you don't know the Agent ID, leave blank</span>
    <div class="buttons">
        <span class="cancel" (click)="cancel()">{{cancelText.toLowerCase()}}</span>
        <span class="submit" (click)="confirm()">{{okText.toLowerCase()}}</span>
    </div>
</div>